import React, { useEffect, useState } from 'react'
import { Modal, Form, Input, Select } from 'antd'
import { DocumentUpload } from '@/components/DocumentUpload'
import type { Brand } from '../types/brand.types'

interface BrandFormModalProps {
    open: boolean
    onCancel: () => void
    onSubmit: (values: any) => void
    initialValues?: Brand | null
}

export const BrandFormModal: React.FC<BrandFormModalProps> = ({
    open,
    onCancel,
    onSubmit,
    initialValues
}) => {
    const [form] = Form.useForm()
    const [isImageUploading, setIsImageUploading] = useState(false)

    useEffect(() => {
        if (open) {
            if (initialValues) {
                form.setFieldsValue(initialValues)
            } else {
                form.resetFields()
                form.setFieldsValue({ status: 'active' })
            }
        }
    }, [open, initialValues, form])

    const handleOk = () => {
        form.validateFields().then(onSubmit)
    }

    return (
        <Modal
            title={initialValues ? "Edit Brand" : "Add New Brand"}
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            okButtonProps={{ disabled: isImageUploading }}
            okText={isImageUploading ? 'Uploading image...' : initialValues ? 'Update Brand' : 'Create Brand'}
            width={600}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label="Brand Name"
                    name="name"
                    rules={[{ required: true, message: 'Please enter brand name' }]}
                >
                    <Input placeholder="Enter brand name" />
                </Form.Item>
                <Form.Item label="Description" name="description">
                    <Input.TextArea rows={3} placeholder="Enter brand description" />
                </Form.Item>
                <Form.Item label="Brand Logo" name="logo">
                    <DocumentUpload documentType="brand_image" onUploadingChange={setIsImageUploading} />
                </Form.Item>
                <Form.Item
                    label="Status"
                    name="status"
                    rules={[{ required: true }]}
                >
                    <Select>
                        <Select.Option value="active">Active</Select.Option>
                        <Select.Option value="inactive">Inactive</Select.Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    )
}
